import React from 'react';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  py?: string; // e.g., 'py-24' or 'py-20'
}
const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, className = '', py = 'py-24' }) => {
  return (
    <section className={`relative ${py} bg-gray-50 overflow-hidden ${className}`}>
      {children}
    </section>
  );
};
export default SectionWrapper; 